export enum AppLinks {
  homepage = '/',
  features = '/features',
  story = '/story',
  terms = '/terms',
  privacy = '/privacy',
}
